<template>
    <gat-form>    
        <gat-group title="Transactions" collapsed=true>
            <template slot="compact">
                {{transactions.length}} transactions
            </template>
            <v-switch class="ml-2" label="Show ignored" v-model="showIgnored"></v-switch>
            <gat-grid :items="transactions" :columns="columns">
                <template slot="customCell" slot-scope="slotProps">
                    <v-btn flat color="primary" @click="manage(slotProps.item)">manage</v-btn>
                <!-- / {{slotProps.item}} -->
                </template>
            </gat-grid>  
        </gat-group>
        
          <gat-group title="Amounts per category" :collapsed=false>
              <amounts-per-category :value="transactions" />
          </gat-group>
              
    </gat-form>
</template>

<script>
    import GatGrid from '@/GatComponents/GatGrid.vue';
    import GatGroup from '@/GatComponents/GatGroup.vue';
    import GatForm from '@/GatComponents/GatForm.vue';
    import GatUtils from '@/GatComponents/GatUtils.js';
    import AmountsPerCategory from '@/components/AmountsPerCategory.vue';
     import { VBtn } from 'vuetify/lib'
    export default {
        name: 'MonthView',
        props: [],
        components: {GatGrid,VBtn,GatGroup,GatForm,AmountsPerCategory},
        data: function() {
            return	{
                showIgnored : false,
                columns:[
                    {header:"Date",field:"TRA_DATE",dataType:"date"},
                    {header:"Amount",field:"TRA_AMOUNT"},                    
                    {header:"Description",field:"TRA_TEXT"},
                    {header:"Category",calculated:(rowdata=>{return GatUtils.lookupCode(rowdata.TRA_CAT_ID,this.$store.state.categories,"CAT_ID","fullName")})},     
                    {header:"Account",field:"TRA_ACCOUNT"}, 
                    {header:"Action",customSlot:true}, 

                ],

            }
        },


        created(){
        },

        computed:{
            transactions(){ 
                let result = [];   
                if(this.$route.params.month=="current"){
                    result = this.$store.state.thisMonthsTransactions
                } else if(this.$route.params.month=="last"){
                    result = this.$store.state.lastMonthsTransactions
                }         
                result = result.filter(item=>{
                    if(this.showIgnored){
                        return true;
                    } else{                    
                        let category = GatUtils.lookupCode(item.TRA_CAT_ID,this.$store.state.categories,"CAT_ID","fullName");                
                        return (category==null) || !category.startsWith("Ignorer.");
                    }
                });
                
                return result.sort((a,b)=>{
                    if (a.CAT_SORT > b.CAT_SORT){
                        return 1
                    } else if (a.CAT_SORT < b.CAT_SORT){
                        return -1
                    } else 
                    return 0;
                });              
            }
        },

        watch:{
        },

        methods:{
            manage(trans){
               let newTrans = GatUtils.makeCopyViaJson(trans);
               this.$store.state.newTransactions.push(newTrans);
            }
        },
    }
</script>

<style scoped>
    .catselect{
        max-width: 300px;
    }
</style>
